import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Custom hook to check if Service Request Reminder Workflow Rule feature is enabled.
 * This feature enables reminder workflows to notify users before service request due dates.
 */
export function useServiceRequestReminderWorkflowRuleEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.ServiceRequestReminderWorkflowRule,
    false
  );

  return Boolean(isEnabled);
}
